export class UpdateTaskResponseDto {
    result: boolean;

    constructor(result: boolean) {

        this.result = result;
    }
}
